import { ExperienceName } from '@atlassian/conversation-assistant-instrumentation/constants/experience-tracker';
import { type AssistantMessage } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { useQuery } from '@atlassian/conversation-assistant-service/common/utils/use-query';
import {
	type AssistanceServiceInjectedParams,
	type AssistanceServiceInputParam,
	createHookWithAssistanceService,
} from '@atlassian/conversation-assistant-service/services/assistance-service/main';

export const useAgentDebugLogsService: (
	props: Omit<
		AssistanceServiceInjectedParams & {
			conversationId: string;
			messageId: string;
		},
		'assistanceServiceInjectedParams'
	> &
		AssistanceServiceInputParam,
) => () => Promise<AssistantMessage | null> = createHookWithAssistanceService(
	({
		assistanceServiceInjectedParams: { assistanceService, experienceTracker },
		conversationId,
		messageId,
	}: AssistanceServiceInjectedParams & { conversationId: string; messageId: string }) => {
		const { refetch } = useQuery({
			queryKey: ['debugLogs', conversationId],
			queryFn: async (): Promise<AssistantMessage> => {
				experienceTracker.start({
					id: ExperienceName.FETCH_AGENT_DEBUG_MODAL_DATA,
					name: ExperienceName.FETCH_AGENT_DEBUG_MODAL_DATA,
				});

				const response = await assistanceService.getConversationDebugLogs(conversationId);

				const messageData = response.find((message) => 'id' in message && message.id === messageId);

				return messageData as AssistantMessage;
			},
			enabled: false,
			onSuccess: () => {
				experienceTracker.succeed({ name: ExperienceName.FETCH_AGENT_DEBUG_MODAL_DATA });
			},
			onError: (error) => {
				experienceTracker.fail({ name: ExperienceName.FETCH_AGENT_DEBUG_MODAL_DATA, error });
			},
		});

		return refetch;
	},
);
